import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-05-30
 * @brief SEI 오늘의 점검 팝업
 *
 ********************************************************************/
import { useEffect, useState } from "react";
//recoil
import { useRecoilState, useSetRecoilState } from "recoil";
import { alertLendingState } from "../../../recoil/assessmentState";
import { reloadAlert } from "../../../recoil/userState";
// utils
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { urlState } from "../../../recoil/menuState";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
function LandingPop(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const [recoilUrlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [alertLendingStates, setAlertLendingStates] = useRecoilState(alertLendingState);
    const setReloadAlerts = useSetRecoilState(reloadAlert);
    //  body
    const [alertB, setAlertB] = useState(false);
    useEffect(() => {
        if (alertB) {
            setAlertLendingStates({
                type: "",
            });
            setAlertB(false);
            setReloadAlerts(false);
        }
    }, [alertB]);
    function AlertUrl(id) {
        CUTIL.jsclose_Popup(id);
        setRecoilUrlInfo(CONST.URL_LOGIN);
        navigate(CONST.URL_LOGIN);
        setAlertB(true);
    }
    function Close(id) {
        if (alertLendingStates.type) {
            CUTIL.jsclose_InPopup(id);
        }
        else {
            CUTIL.jsclose_Popup(id);
        }
        setAlertB(true);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop1", className: "popup-layer js-layer hidden popup-basic" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.로그인") }), _jsx("button", Object.assign({ className: "btn btn-close ", onClick: (e) => Close("pop1") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx(Trans, Object.assign({ i18nKey: "메뉴.로그인" }, { children: _jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("p", Object.assign({ className: "font-15 txt-center mt-7" }, { children: "\uB85C\uADF8\uC778\uC774 \uD544\uC694\uD55C \uC11C\uBE44\uC2A4\uC785\uB2C8\uB2E4." })), _jsx("p", Object.assign({ className: "font-15 txt-center mt-7" }, { children: "\uB85C\uADF8\uC778 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop1") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "", onClick: (e) => AlertUrl("pop1") }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] })) }));
}
export default LandingPop;
